<template>
  <c-dialog ref="dialog" height="580" width="600" @resolve="editHandle">
    <c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="类目" required tip="请选择关联类目">
        <c-select name="category_id" async @search="searchCategory" v-model="categoryId" :value-data="selectedCategory" :disabled="!changeGroupFlag"></c-select>
      </c-form-item>
      <c-form-item label="分组" required tip="请选择关联分组">
        <c-select name="release_group_id" async @search="searchGroup" v-model="releaseGroupId" :value-data="selectedGroup" :disabled="!categoryId || !changeGroupFlag"></c-select>
      </c-form-item>
      <c-form-item label="质检项" required tip="请选择质检项">
        <c-select name="parent_id" async @search="searchReleaseParent" v-model="parentId" :value-data="selectedReleaseParent" :disabled="!categoryId || !releaseGroupId || !changeGroupFlag"></c-select>
      </c-form-item>
      <c-form-item label="质检项值" required tip="同一分组下，名称不允许重复">
        <c-input name="name" maxlength="100"></c-input>
      </c-form-item>
      <c-form-item label="是否瑕疵项" required :tip="releaseTypeWord">
          <c-radio-group name="release_type" v-model="releaseType" :options="releaseTypeOptions"></c-radio-group>
      </c-form-item>
      <c-form-item label="是否需传瑕疵图" required v-show="releaseType == 2" tip="选择“需要”，则在质检时，必须上传瑕疵图">
          <c-radio-group name="defect_image" v-model="defectImage" :options="defectImageOptions"></c-radio-group>
      </c-form-item>
      <c-form-item label="备注">
        <c-input name="remark" maxlength="20"></c-input>
      </c-form-item>
    </c-form>
  </c-dialog>
</template>

<script>
export default {
  computed: {
    releaseTypeWord() {
      return {
        '1': '质检正常项，展示为绿色',
        '2': '质检发现瑕疵，展示为红色'
      }[this.releaseType]
    }
  },

  data() {
    return {
      changeGroupFlag:false,//是否允许变更所属分组  true = 允许 （树形表格中不允许变更上级）
      editState: false,
      categoryId:0,
      selectedCategory:[], //已选中的类目
      releaseGroupId:0,
      selectedGroup:[], //已选中的分组
      parentId:0,//已选中的父级质项ID
      selectedReleaseParent:[], //已选中的父级质检项
      releaseType:1,    //发布项类型 1：正常项（绿色） 2：异常项（红色）
      releaseTypeOptions:[
          {name: '正常项',value: '1'},
          {name: '瑕疵项',value: '2'}
      ],
      defectImage: 2,
      //是否需要上传瑕疵图（1-是 2-否）
      defectImageOptions: [
        {name: '需要', value: '1'},
        {name: '不需要', value: '2'}
      ]
    }
  },

  methods: {
    /*******搜索类目*****************/
    searchCategory(keyword, resolve){
      this.request({
        url:'/spu/category/options',
        data: {
          keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },
    /*******搜索分组*****************/
    searchGroup(keyword, resolve){
      this.request({
        url:'/spu/release/group/options',
        data: {
          category_id:this.categoryId,
          keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },
    /*******搜索父级质检项*****************/
    searchReleaseParent(keyword, resolve){
      this.request({
        url:'/spu/release/parent/options',
        data: {
          category_id:this.categoryId,
          release_group_id:this.releaseGroupId,
          keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },
    /*******通过ID查询父级质检项详情*****************/
    getReleaseParentDetail(id){
      this.request({
        url:'/spu/release/parent/detail',
        data: {
          id:id
        },
        success:data => {
          this.selectedCategory = [{
              name: data.category_name,
              value:data.category_id
          }];
          this.categoryId = data.category_id;
          //已选中的[分组]
          this.selectedGroup = [{
              name: data.group_name,
              value:data.release_group_id
          }];
          this.releaseGroupId = data.release_group_id;
          //已选中的[父级质检项]
          this.parentId = data.parent_id;
          this.selectedReleaseParent = [{
              name: data.name,
              value:data.id
          }];
        }
      })
    },

    /*********打开编辑框，初始化**********/
    open(data,release_id) {
      this.editState = !!data;
      this.changeGroupFlag = !release_id;
      this.$refs.form.clear();
      //清除数据
      this.categoryId = 0,
      this.selectedCategory = [];
      this.releaseGroupId = 0;
      this.selectedGroup = [];
      this.parentId = 0;
      this.selectedReleaseParent = [];
      if (data) {
          //已选中的[类目]
          this.selectedCategory = [{
            name: data.category_name,
            value:data.category_id
          }];
          this.categoryId = data.category_id;
          //已选中的[分组]
          this.selectedGroup = [{
            name: data.group_name,
            value:data.release_group_id
          }];
          this.releaseGroupId = data.release_group_id;
          this.selectedReleaseParent = [{
            name: data.parent_name,
            value:data.parent_id
          }];
          this.$refs.form.set(data);
      }else if (release_id){
          this.getReleaseParentDetail(release_id);
          this.releaseType = 1;   //发布项类型 1：正常项（绿色） 2：异常项（红色）
          this.$refs.form.set({
              release_type:this.releaseType,
              defect_image:this.defectImage
          });
      }else {
          this.$refs.form.set({
              release_type:this.releaseType,
              defect_image:this.defectImage
          });
      }
      //填充form表单
      this.$refs.dialog.open({
        title: data ? '编辑质检项值' : '添加质检项值'
      });
    },

    /*******添加、编辑提交处理方法********/
    editHandle (stop, next){
      stop();
      this.$refs.form.submit({
        url: this.editState?'/spu/release/edit':'/spu/release/add',
        rule: {
            category_id: '请选择关联的类目',
            release_group_id: '请选择关联的质检分组',
            parent_id: '请选择质检项',
            name: '请输入质检项值',
            release_type: '请选择是否是瑕疵项'
        },
        dataFormatter: data => {
            data.defect_image = this.defectImage||2;
            return data;
        },
        success: (data, res) => {
          next();
          if(this.editState){
            this.$message({
              message: '编辑成功',  // 提示内容,
              type: 'success'
            });
          }else{
            this.$message({
              message: '添加成功',  // 提示内容,
              type: 'success'
            });
          }
          this.$emit('resolve',res);
        }
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>